import { BACKEND_URL } from "./api";

const KEY = "termonline_consent";

export const getConsent = () => {
  try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
};

export const saveConsent = (c) => {
  const v = { analytics: !!c.analytics, marketing: !!c.marketing, ts: new Date().toISOString() };
  localStorage.setItem(KEY, JSON.stringify(v));
  window.dispatchEvent(new CustomEvent("consent-changed", { detail: v }));
  return v;
};

function gtag() { window.dataLayer.push(arguments); }

function addScript(id, src) {
  if (document.getElementById(id)) return;
  const s = document.createElement("script");
  s.id = id; s.async = true; s.src = src;
  document.head.appendChild(s);
}

export function applyTracking(tracking, consent) {
  const ga4 = tracking?.ga4_id?.trim();
  const gtm = tracking?.gtm_id?.trim();
  const pixel = tracking?.meta_pixel_id?.trim();
  if (!ga4 && !gtm && !pixel) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || gtag;
  if (!window.__consentDefault) {
    window.gtag("consent", "default", { ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied", analytics_storage: "denied" });
    window.__consentDefault = true;
  }
  if (!consent) return;
  const g = (v) => (v ? "granted" : "denied");
  window.gtag("consent", "update", {
    analytics_storage: g(consent.analytics), ad_storage: g(consent.marketing),
    ad_user_data: g(consent.marketing), ad_personalization: g(consent.marketing),
  });
  if (!consent.analytics && !consent.marketing) return;
  if (pixel && consent.marketing) loadPixel(pixel);
  if (gtm) {
    window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
    addScript("gtm-script", `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtm)}`);
  }
  if (ga4) {
    addScript("ga4-script", `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ga4)}`);
    window.gtag("js", new Date());
    window.gtag("config", ga4);
  }
}

function loadPixel(id) {
  if (window.fbq) return;
  const n = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
  window.fbq = n;
  if (!window._fbq) window._fbq = n;
  n.push = n; n.loaded = true; n.version = "2.0"; n.queue = [];
  addScript("meta-pixel", "https://connect.facebook.net/en_US/fbevents.js");
  window.fbq("init", id);
  metaSend("PageView");
}

const cookie = (n) => document.cookie.split("; ").find((c) => c.startsWith(`${n}=`))?.split("=")[1];
const getFbc = () => {
  const c = cookie("_fbc");
  if (c) return c;
  const id = new URLSearchParams(window.location.search).get("fbclid");
  return id ? `fb.1.${Date.now()}.${id}` : undefined;
};
const uid = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);

export function metaSend(name, params = {}, user = {}) {
  if (typeof window.fbq !== "function") return;
  const id = uid();
  window.fbq(name === "PageView" || META_STANDARD.has(name) ? "track" : "trackCustom", name, params, { eventID: id });
  const { page, ...custom } = params;
  fetch(`${BACKEND_URL}/api/meta/track`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    keepalive: true,
    body: JSON.stringify({
      event_name: name, event_id: id, marketing_consent: !!getConsent()?.marketing,
      event_source_url: window.location.href, fbp: cookie("_fbp"), fbc: getFbc(), custom_data: custom, ...user,
    }),
  }).catch(() => {});
}

export const META_EVENTS = [
  ["ViewContent", "Visualizzazione contenuto"],
  ["Lead", "Lead (contatto acquisito)"],
  ["Purchase", "Acquisto"],
  ["Contact", "Contatto"],
  ["Schedule", "Prenotazione appuntamento"],
  ["SubmitApplication", "Invio candidatura/richiesta"],
  ["CompleteRegistration", "Registrazione completata"],
  ["InitiateCheckout", "Inizio pagamento"],
  ["AddPaymentInfo", "Aggiunta dati di pagamento"],
  ["AddToCart", "Aggiunta al carrello"],
  ["AddToWishlist", "Aggiunta alla lista desideri"],
  ["CustomizeProduct", "Personalizzazione prodotto"],
  ["Donate", "Donazione"],
  ["FindLocation", "Ricerca sede"],
  ["Search", "Ricerca"],
  ["StartTrial", "Inizio prova"],
  ["Subscribe", "Abbonamento"],
];
const META_STANDARD = new Set(META_EVENTS.map(([k]) => k));

export const eventName = (ev) => (ev?.meta_event === "Custom" ? String(ev?.custom_name || "").trim() : String(ev?.meta_event || "").trim());

export function eventParams(ev, extra = {}) {
  const p = { ...extra };
  const v = parseFloat(String(ev?.value || "").replace(",", "."));
  if (!Number.isNaN(v)) { p.value = v; p.currency = ev?.currency || "EUR"; }
  return p;
}

const normPath = (u) => {
  const s = String(u || "").trim();
  if (!s) return "";
  try {
    const url = new URL(s, window.location.origin);
    return (url.pathname.replace(/\/+$/, "") || "/") + url.search;
  } catch { return s; }
};

export function matchesUrl(ev) {
  const raw = String(ev?.url || "").trim();
  if (!raw) return true;
  const here = (window.location.pathname.replace(/\/+$/, "") || "/") + window.location.search;
  if (ev?.match === "esatto") return normPath(raw) === here;
  const needle = raw.toLowerCase();
  return window.location.href.toLowerCase().includes(needle) || here.toLowerCase().includes(normPath(raw).toLowerCase());
}

export function fireEvent(ev, params = {}, user = {}) {
  const name = eventName(ev);
  if (!name) return;
  params = eventParams(ev, params);
  const where = String(ev.platforms || "tutte").toLowerCase();
  const all = !where.trim() || where.includes("tutte");
  window.dataLayer = window.dataLayer || [];
  if (all || where.includes("gtm")) window.dataLayer.push({ event: name, ...params });
  if ((all || where.includes("ga4")) && typeof window.gtag === "function") window.gtag("event", name, params);
  if (all || where.includes("meta")) metaSend(name, params, user);
}

export const eventsFor = (tracking, trigger) =>
  (Array.isArray(tracking?.events) ? tracking.events : []).filter((e) => e?.enabled !== false && e?.trigger === trigger && eventName(e));

export function matchesTarget(el, target) {
  const t = String(target || "").trim();
  if (!t || !el?.closest) return false;
  if (/^(https?:|tel:|mailto:)/i.test(t)) return !!el.closest(`a[href^="${t.replace(/"/g, "")}"]`);
  if (/^[.#[]/.test(t)) {
    try { return !!el.closest(t); } catch { return false; }
  }
  const node = el.closest("a,button");
  return !!node && node.textContent.toLowerCase().includes(t.toLowerCase());
}

export function trackConversion(tracking, params = {}, user = {}) {
  const name = tracking?.conversion_event || "generate_lead";
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...params });
  if (typeof window.gtag === "function") window.gtag("event", name, params);
  eventsFor(tracking, "invio_modulo").filter(matchesUrl).forEach((ev) => fireEvent(ev, params, user));
}
